export default __webpack_public_path__ + "315c14333bb24f0dd7b56521b7c7912c.png";